module.exports = __webpack_public_path__ + "static/media/screenshot_history_6_en.8eab08ff.png";